import { Box, Checkbox, FormControlLabel, Typography } from '@mui/material';
import { DateInput, SelectInput, SelectOption } from 'lib/common/Inputs';
import PageHeader from 'lib/designSystem/PageHeader';
import React from 'react';

import { IBankAccount } from '../types';

export interface StepCashPaymentProps {
  originAccounts: IBankAccount[];
  bankAccountOriginId: number | null;
  onBankAccountChange: (id: number | null) => void;
  forceExecutedAt: boolean;
  onForceExecutedAtChange: (force: boolean) => void;
  executedAt: string;
  onExecutedAtChange: (date: string) => void;
}

const StepCashPayment: React.FC<StepCashPaymentProps> = ({
  originAccounts,
  bankAccountOriginId,
  onBankAccountChange,
  forceExecutedAt,
  onForceExecutedAtChange,
  executedAt,
  onExecutedAtChange,
}) => {
  const bankOptions: SelectOption<number>[] = originAccounts.map((acc) => ({
    value: acc.id,
    label: `${acc.bankName} (${acc.accountNumber})`,
  }));

  return (
    <div>
      <Box
        sx={{
          mt: 3,
          mx: 'auto',
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
          maxWidth: '700px',
        }}
      >
        <PageHeader variant="dialogHeader">
          <PageHeader.Main>
            <PageHeader.TitleSection
              title="Registrar pago al contado"
              subtitle="Seleccione el banco de origen y la fecha con la cual desea registrar el pago."
              iconType="payment"
            />
          </PageHeader.Main>
        </PageHeader>

        <SelectInput
          label="Banco de origen"
          value={bankAccountOriginId}
          options={bankOptions}
          onChange={onBankAccountChange}
        />

        <FormControlLabel
          control={
            <Checkbox
              color="primary"
              checked={forceExecutedAt}
              onChange={(e) => onForceExecutedAtChange(e.target.checked)}
            />
          }
          label={
            <Typography
              variant="h5"
              sx={{ fontWeight: 500, color: 'text.primary', fontSize: '1rem' }}
            >
              ¿Quieres forzar la fecha de giro a alguna en particular?
            </Typography>
          }
        />

        {forceExecutedAt && (
          <DateInput
            label="Fecha de giro"
            value={executedAt}
            onChange={onExecutedAtChange}
          />
        )}
      </Box>
    </div>
  );
};

export default StepCashPayment;
